import ButtonCloseMenu from 'components/button-close'
import useMainClass from 'hooks/use-main-cass'
import { QRCodeCanvas } from 'qrcode.react'
import { Input } from 'theme/theme'

interface IProps {
  setShowOrderNumber: (value: boolean) => void
  details: any
}

const NumberOrder = ({ setShowOrderNumber, details }: IProps) => {
  useMainClass('profile__history__numberorder')

  return (
    <>
      <ButtonCloseMenu paramFn={() => setShowOrderNumber(null)} />

      <div className="profile__history__number-order">
        <div className="profile__history__number-order__qr">
          <QRCodeCanvas
            style={{ width: '230px', height: '230px' }}
            id="qr-number-order"
            value={details?.id}
            className="w-full"
          />
        </div>

        <div className="profile__history__number-order__container">
          <p className="profile__history__number-order__text">NÚMERO DE ORDEN</p>
          <Input className="profile__history__number-order__input" value={details?.id} readOnly />
        </div>
      </div>
    </>
  )
}

export default NumberOrder
